import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { MultipleImageField } from "@/components/ui/form/fields/image-field/multiple";

type Props = {
	hasFeatureIslandCategoryContext?: boolean;

	ownerID: string;
	resourceID: string;

	keyVisuals: ForArrayType<S3Object[] | undefined> | undefined;
	KVsErrorMessage: string | undefined;
	onSetKeyVisuals: (props: S3Object[]) => void;
};

export const QuestionKeyVisuals = ({
	hasFeatureIslandCategoryContext = true,
	keyVisuals,
	KVsErrorMessage,
	onSetKeyVisuals,
	ownerID,
	resourceID,
}: Props) => {
	const isEdited = Boolean(keyVisuals?.value?.length);
	const hasError = keyVisuals?.hasError ?? false;

	const images = keyVisuals?.value?.map((image) => {
		return {
			key: image.key.value,
			bucket: image.bucket.value,
			region: image.region.value,
			mimeType: image.mimeType?.value,
			fileName: image.fileName?.value,
		} satisfies S3Object;
	});

	return (
		<>
			{keyVisuals && (
				<Accordion type={"single"} collapsible defaultValue={isEdited ? "room-key-visuals" : undefined}>
					<AccordionItem value="room-key-visuals">
						<AccordionTrigger>キービジュアルを複数枚設定する</AccordionTrigger>

						<AccordionContent>
							{hasFeatureIslandCategoryContext ? (
								<FeatureIslandCategoryQuestionForMain
									required={false}
									title={"キービジュアル（複数枚）"}
									guide="推奨画像アスペクト比は16:9です。"
									hasError={hasError}
									isEdited={isEdited}
									inputChildren={
										<MultipleImageField
											errorMessage={KVsErrorMessage}
											images={images}
											onSetKeyVisuals={onSetKeyVisuals}
											ownerID={ownerID}
											resourceID={resourceID}
										/>
									}
								/>
							) : (
								<QuestionForMain
									required={false}
									title={"キービジュアル（複数枚）"}
									guide="推奨画像アスペクト比は16:9です。"
									inputChildren={
										<MultipleImageField
											errorMessage={KVsErrorMessage}
											images={images}
											onSetKeyVisuals={onSetKeyVisuals}
											ownerID={ownerID}
											resourceID={resourceID}
										/>
									}
								/>
							)}
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			)}
		</>
	);
};

QuestionKeyVisuals.displayName = "QuestionKeyVisuals";
